import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initializeSQLiteStorage } from "@/utils/sqliteStorage";
import { consumeWebAuthRedirectResult } from "@/utils/firebase";

const root = ReactDOM.createRoot(document.getElementById("root"));

const bootstrap = async () => {
  if (typeof window !== "undefined") {
    try {
      await consumeWebAuthRedirectResult();
    } catch (e) {
      console.warn("[firebase] bootstrap getRedirectResult:", e?.message || e);
    }
  }
  await initializeSQLiteStorage();
  root.render(
    <App />
  );
};

bootstrap();